import "./Navbar.css";
import logo from "./images/logo.svg";
import { useNavigate, useLocation } from "react-router-dom";

function Navbar({ admin = false }) { // Adding the optional 'admin' parameter
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location

  const isAdminPage = location.pathname === "/admin"; // Check if the current page is the admin page

  return (
    <div className="navbar">
      <img
        src={logo}
        className="logo"
        alt="logo"
        onClick={() => navigate("/dashboard")}
      />
      {admin && (
        <button
          className="admin-btn"
          onClick={() => navigate(isAdminPage ? "/dashboard" : "/admin")}
        >
          {isAdminPage ? "Dashboard" : "Admin Tools"}
        </button>
      )}
    </div>
  );
}

export default Navbar;